import * as React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import { CMSState, Id, ImageSize } from "../../../../cms/blocks/types.gen";
import { ImageContainer } from "../../../../cms/blocks/widgets/ImageContainer.gen";
import { extra_images, quotesblock_src, quotesblock_srcset } from "../../../utils/extra_images.mod";
import { Pair } from "widgets-for-react";
import { parseImageUrl } from "../../../../drupal/rendering/image_utils.mod";
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types";

export type QuotesBlockProps = {
  title?: string;
  quotes: QuoteSlideProps[];
  cmsState?: CMSState<any, extra_images, never>
  isStyleguide?: boolean
}

export type QuoteSlideProps = {
  field_image?: ParsedMediaImage
  image?: Id
  image_alt?: string
  image_size?: ImageSize<extra_images>

  imageStyleguide?: {
    src: string;
    srcSet: string;
    alt: string;
  }

  person?: string;
  person_function?: string;
  quote?: string;

  btn?: {
    url: string;
    label: string;
  }
}

export const QuotesBlock = (props: QuotesBlockProps) => {
  const {
    title,
    quotes,
    cmsState,
    isStyleguide,
  } = props;

  return (
    <section className="quotes">
      <div className="quotes__inner">
        <div className="container container--m grid--gutter">
          {title &&
            <h2 className="quotes__title title--l">{title}</h2>
          }
          <Swiper
            className="quotes__carousel carousel"
            modules={[Navigation, Pagination]}
            spaceBetween={40}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
          >
            {quotes.map((slide, index) => {
              const {
                field_image,
                image,
                image_alt,
                image_size,
                person,
                person_function,
                quote,
                btn,
                imageStyleguide,
              } = slide;

              return (
                <SwiperSlide className="carousel__slide">
                  <div className="carousel__inner">
                    <div className="carousel__column carousel__column--visual">
                      <div className="carousel__visual">
                        {isStyleguide ?
                          <img className="carousel__image lazyload"
                            src="/frontend/images/empty.png"
                            data-src={imageStyleguide.src}
                            data-srcSet={imageStyleguide.srcSet}
                            alt={imageStyleguide.alt}
                            sizes="auto"
                            width="440"
                            height="440"
                          />
                          : image &&
                          <div className="carousel__visual">
                            <img className="carousel__image lazyload"
                              src="/frontend/images/empty.png"
                              data-src={`${field_image?.field_media_image?.image?.style_urls['450x450']}`}
                              data-srcset={`${parseImageUrl(
                                field_image?.field_media_image?.image?.style_urls['450x450']
                              )} 450x450, ${parseImageUrl(
                                field_image?.field_media_image?.image?.style_urls['600x600']
                              )} 600x600, ${parseImageUrl(
                                field_image?.field_media_image?.image?.style_urls['1200x1200']
                              )}`}
                              alt={image_alt}
                              sizes="auto"
                              width="450"
                              height="450"
                            />
                          </div>
                        }
                      </div>
                    </div>
                    <div className="carousel__column carousel__column--message">
                      <div className="carousel__message">
                        <figure className="carousel__quote">
                          {person && <figcaption className="carousel__label">{`${person}, ${person_function}`}</figcaption>}
                          {quote && <blockquote className="carousel__title title--l">{quote}</blockquote>}
                        </figure>
                        {
                          btn &&
                            <Link className="carousel__link link link--secondary text--l" to={btn.url}>{btn.label}</Link>
                        }
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>
      </div>
    </section>
  )
}